import queryString from 'query-string';
import { rootDomain, isPreview as isPreviewEnv, isStaging, vercelRelatedProjects } from './env';

export default function getCheckoutPreviewUrl(
  page = {},
  seller = {},
  {
    isTesting = false,
    isTestingPayments = false,
    isPreview = false,
    variant,
    previewKey,
    isConfirmation = false,
    usePageId = false,
  } = {},
) {
  const pageUrlId = usePageId ? page._id : page.slug || page._id;
  const sellerUrlId = seller.name ? seller.name : seller._id;

  let checkoutUrl = `https://${sellerUrlId}.${rootDomain}/${pageUrlId}`;

  if (variant === 'site_embed' || variant === 'site_upsell_embed') {
    checkoutUrl = `https://${sellerUrlId}.${rootDomain}/embed/${pageUrlId}`;
  }

  if (variant === 'site_popup' || variant === 'site_upsell_popup') {
    checkoutUrl = `https://${sellerUrlId}.${rootDomain}/overlay/${pageUrlId}`;
  }

  if (variant === 'qr_code') {
    checkoutUrl = `https://${sellerUrlId}.${rootDomain}/${pageUrlId}/qr`;
  }

  // if the environment is preview, we need to replace the root domain with the store host
  if (isPreviewEnv && !isStaging) {
    // get the store preview project
    let storePreviewProject = null;
    try {
      storePreviewProject = JSON.parse(vercelRelatedProjects)?.find(
        project => project.project.name === 'checkoutpage-mono-store',
      );
    } catch (error) {
      // no-op
    }

    // get the preview branch url
    const previewBranchUrl = storePreviewProject?.preview?.branch
      ? `https://${storePreviewProject.preview.branch}`
      : `https://${rootDomain}`;

    // replace the root domain with the store preview branch url
    if (previewBranchUrl) {
      checkoutUrl = checkoutUrl.replace(
        `https://${sellerUrlId}.${rootDomain}`,
        `${previewBranchUrl}`,
      );

      if (checkoutUrl.includes('embed') || checkoutUrl.includes('overlay')) {
        // if the url includes embed or overlay, we need to replace the page id with the seller id and page id
        checkoutUrl = checkoutUrl.replace(`/${pageUrlId}`, `/${sellerUrlId}/${pageUrlId}`);
      } else {
        checkoutUrl = checkoutUrl.replace(`/${pageUrlId}`, `/c/${sellerUrlId}/${pageUrlId}`);
      }
    }
  }

  if (isConfirmation) {
    checkoutUrl = `${checkoutUrl}/confirmation/${Math.random()}`;
  }

  const url = queryString.stringifyUrl({
    url: checkoutUrl,
    query: {
      ...(isTesting && { testing: true }),
      ...(isTestingPayments && { testingPayments: true }),
      ...(isPreview && { preview: true }),
      ...(previewKey && { previewKey }),
      ...((variant === 'hosted_upsell_page' ||
        variant === 'site_upsell_embed' ||
        variant === 'site_upsell_popup') && {
        upsell: true,
      }),
    },
  });

  return url;
}
